import values from 'lodash/values'
import type { RouteDef } from '@ztechapps/common.contract'

/**
 * OwnText Admin routes definition.
 * Per OWN-07 Section 4.1 - Primary Navigation:
 * - Dashboard
 * - Queues (deferred - uses message status for now)
 * - Inbox
 * - Outbox
 * - Settings (SIMs, Projects, API Keys, Webhooks, Queue Settings)
 */
export const routesDef = {
  // Dashboard
  DashboardPage: {
    name: 'Dashboard',
    path: '/app/dashboard',
    exact: true,
    layout: 'main',
  },

  // Messages - Inbox
  InboxPage: {
    name: 'Inbox',
    path: '/app/inbox',
    exact: true,
    layout: 'main',
  },
  InboxItemPage: {
    name: 'Inbox Message',
    path: '/app/inbox/:_id',
    altPath: ({ _id }: { _id: string }) => `/app/inbox/${encodeURIComponent(_id)}`,
    exact: true,
    layout: 'main',
  },

  // Messages - Outbox
  OutboxPage: {
    name: 'Outbox',
    path: '/app/outbox',
    exact: true,
    layout: 'main',
  },
  OutboxItemPage: {
    name: 'Outbox Message',
    path: '/app/outbox/:_id',
    altPath: ({ _id }: { _id: string }) => `/app/outbox/${encodeURIComponent(_id)}`,
    exact: true,
    layout: 'main',
  },

  // Settings
  SettingsPage: {
    name: 'Settings',
    path: '/app/settings',
    exact: true,
    layout: 'main',
  },
  SettingsSimsPage: {
    name: 'SIMs & Gateways',
    path: '/app/settings/sims',
    exact: true,
    layout: 'main',
  },
  SettingsProjectsPage: {
    name: 'Projects',
    path: '/app/settings/projects',
    exact: true,
    layout: 'main',
  },
  SettingsProjectItemPage: {
    name: 'Project',
    path: '/app/settings/projects/:_id',
    altPath: ({ _id }: { _id: string }) => `/app/settings/projects/${encodeURIComponent(_id)}`,
    exact: true,
    layout: 'main',
  },
  SettingsWebhooksPage: {
    name: 'Webhooks',
    path: '/app/settings/webhooks',
    exact: true,
    layout: 'main',
  },
  SettingsQueuePage: {
    name: 'Queue Settings',
    path: '/app/settings/queue',
    exact: true,
    layout: 'main',
  },
  SettingsOrganizationPage: {
    name: 'Organization',
    path: '/app/settings/organization',
    exact: true,
    layout: 'main',
  },

  // Auth pages
  LoginPage: {
    name: 'Login',
    path: '/account/login',
    altPath: () => '/account/login',
    exact: true,
    layout: 'blank',
  },
  JoinPage: {
    name: 'Join',
    path: '/account/join',
    altPath: () => '/account/join',
    exact: true,
    layout: 'blank',
  },
  ChangePasswordPage: {
    name: 'ChangePassword',
    path: '/account/change-password/:editPassword?',
    altPath: () => '/account/change-password',
    exact: true,
    layout: 'blank',
  },
  AuthSuccessPage: {
    name: 'Auth Success',
    path: '/auth/success/:auth',
    exact: true,
    layout: 'blank',
  },
  AuthFailedPage: {
    name: 'Auth Failed',
    path: '/auth/failed',
    exact: true,
    layout: 'blank',
  },
  LoadingPage: {
    name: 'Loading',
    path: '/',
    exact: true,
    layout: 'blank',
  },
} as const satisfies Record<string, RouteDef>

export const routesArray = values(routesDef)
